module.exports = __webpack_public_path__ + "img/stamp-fruit-roots-orange.f4154c1c.png";